import { type ForwardedRef, forwardRef, type InputHTMLAttributes } from "react";

interface TextareaInputProps extends InputHTMLAttributes<HTMLTextAreaElement> {
    id: string;
    labelText?: string;
    required?: boolean;
    isInvalid?: boolean;
    errorMessage?: string;
    placeholder?: string;
}

const TextareaInput = (
    { id, labelText, required, isInvalid, errorMessage, placeholder, ...rest }: TextareaInputProps,
    ref: ForwardedRef<HTMLTextAreaElement>
) => {
    return (
        <div className="form-group mb-3">
            {labelText && (
                <label className="mb-2" htmlFor={id}>
                    {labelText}
                    {required && <span className="text-danger">*</span>}
                </label>
            )}

            <textarea
                {...rest}
                id={id}
                ref={ref}
                name={id}
                className={`form-control mb-0 ${isInvalid ? "is-invalid" : ""}`}
                placeholder={placeholder ?? (!placeholder && labelText && `Enter ${labelText}`)}
                required={required}
                autoComplete="off"
            ></textarea>
            {isInvalid && <div className="invalid-feedback">{errorMessage ?? "Invalid Value"}</div>}
        </div>
    );
};

export default forwardRef<HTMLTextAreaElement, TextareaInputProps>(TextareaInput);
